export const FB_INIT_ID = '313388378811698';

export const FB_TRACK = {
  PAGE_VIEW: 'PageView',
  LEAD_CREATION: 'LS_Holiday_Lead',
  BOOK_ONLINE: 'LS_BookOnline',
  PROCEED_TO_PAYMENT: 'LS_ProceedPayment',
  THANK_YOU_PAGE: 'LS_Purchase',
  PACKAGE_SEARCH: 'LS_Search',
  SEND_QUERY_CTA: 'LS_GetACallBack',
  MYRA_CHAT_CTA: 'LS_LiveChat',
  QUERY_SUBMIT: 'LS_Longhaul_SubmitQuery',
};

export const TRACK_TYPE = {
  PAGE_VIEW: 'PAGE_VIEW',
  LEAD_CREATION: 'LEAD_CREATION',
  BOOK_ONLINE: 'BOOK_ONLINE',
  PROCEED_TO_PAYMENT: 'PROCEED_TO_PAYMENT',
  THANK_YOU_PAGE: 'THANK_YOU_PAGE',
  PACKAGE_SEARCH: 'PACKAGE_SEARCH',
  SEND_QUERY_CTA: 'SEND_QUERY_CTA',
  MYRA_CHAT_CTA: 'MYRA_CHAT_CTA',
  QUERY_SUBMIT: 'QUERY_SUBMIT',
};
